import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import UltimateBackground from "../../components/UltimateBackground/UltimateBackground"
import { PurchasProvider } from "../../context/purchaseContext"
import FeatureList from "./PremiumPromoFeatureList/PremiumPromoFeatureList"
import Footer from "./Footer/Footer"
import Header from "./Header/Header"
import styles from "./EmailPromoPaywall.module.scss"
import { useAppState } from "../../context/appStateContext"
import { useEffect } from "react"

const EmailPromoPaywall = () => {
  const actions = useAppState().actions

  useEffect(() => {
    actions.setIgnoreHeaderInset(true)
  }, [])

  return (
    <PurchasProvider>
      <FullScreenPage containerClassName={styles.page}>
        <div className={styles.container}>
          <Header />
          <FeatureList />
          <Footer />
        </div>
        <UltimateBackground forceVisible style={{ zIndex: 0 }} />
      </FullScreenPage>
    </PurchasProvider>
  )
}

export default EmailPromoPaywall
